<div class="cropper-img">
  <label for="btn" class="upload-btn" >上传需要被裁剪的图片</label>
  <input id="btn" #imageInput accept=".jpg,.png,.jpeg" type="file" style="display: none;" (change)="imageChangeEvent($event)">
  <div class="copperArea">
    <div class="leftCopper">
      <img  #imgCropper class="cropperMain" />
    </div>
    <div class="rightPreview">
      <div>
        <div class="liTitle">预览</div>
        <img class="preImg" [src]="croppedImage" />
      </div>

      <div>
        <div class="liTitle">工具</div>
        <div class="toolArea ">
          <div class="J_KnowBtn btnTheme" (click)="rotateImage()">旋转图片</div>
          <div class="J_KnowBtn btnTheme" (click)="sureCropper()">确认裁剪</div>
        </div>
      </div>
    </div>
  </div>
</div>
